import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

export default function App() {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [Joke, setJoke] = useState("");
  const [error, setError] = useState(null);
  const [categoryError, setCategoryError] = useState("");

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(
          "https://api.chucknorris.io/jokes/categories"
        );
        if (!response.ok) throw new Error("Nije učitana lista kategorija.");
        const data = await response.json();
        setCategories(data);
      } catch (error) {
        setError(error);
      }
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    setJoke("");
    setCategoryError("");
  }, [selectedCategory]);

  const fetchJoke = async (event) => {
    event.preventDefault();

    if (!selectedCategory) return;

    const selectedCategoryLower = selectedCategory.toLowerCase();

    const matchingCategory = categories.find(
      (category) => category.toLowerCase() === selectedCategoryLower
    );

    if (!matchingCategory) {
      setCategoryError("No, pokušaj ponovo.");
      setJoke("");
      return;
    }

    setCategoryError("");
    setJoke("");

    try {
      const response = await fetch(
        `https://api.chucknorris.io/jokes/random?category=${matchingCategory}`
      );
      if (!response.ok) throw new Error("No jokee ");
      const data = await response.json();
      setJoke(data.value);
    } catch (error) {
      setError(error);
    }
  };

  if (error)
    return <p className="text-center text-danger">Error: {error.message}</p>;

  return (
    <div className="container text-center py-3">
      <h1 className="display-1 py-3">Izaberi Chuck Norris joke kategoriju</h1>

      <div className="form-group">
        <label className="mt-2" htmlFor="category">
          Kategorije:
        </label>
        <input
          type="text"
          id="category"
          className="form-control"
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
          placeholder="Upiši Joke Kategoriju"
        />
        <small className="form-text text-muted">
          Moguće kategorije: {categories.join(", ")}
        </small>
      </div>

      {categoryError && <p className="text-danger mt-2">{categoryError}</p>}

      <div className="d-grid gap-2 col-6 mx-auto">
        <button
          className="btn btn-secondary mt-4"
          onClick={fetchJoke}
          disabled={!selectedCategory}
        >
          Stisni za Joke
        </button>
      </div>

      <div className="mt-4">
        <h3>JOKE:</h3>

        <p className="text-secondary">
          {Joke ? Joke : "Ovdje će se nalaziti šala"}
        </p>
      </div>
    </div>
  );
}
